<template>
  <div class="container">
    <p class="text">
      Przepraszamy, ale właśnie trwa krótka przerwa techniczna.
    </p>
    <p class="text">
      Prosimy spróbować ponownie niebawem.
    </p>
  </div>
</template>

<script>

export default {}
</script>

<style lang="scss" scoped>
  .container {
    @include center-content;
    flex-direction: column;
    text-align: center;
    height: 100vh;
    width: 100%;
  }

  .text {
    @include main-title;
    max-width: 80%;
    margin-bottom: 0.5em;

    @include media-down(md) {
      font-size: 20px;
    }
  }
</style>
